<!--
     <Select
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - items → [[value, text], [1, 'User 1']]
     - value
     - label
     - placeholder
     - multiple
-->

<template>
  <v-select
    v-model="props.value"
    :items="props.items"
    :label="props.label"
    :placeholder="props.placeholder"
    :multiple="props.multiple"
    :readonly="!!props.readonly"
    item-text="1"
    item-value="0"
    :rules="rules"
    :class="[props.class || 'qmkey-form-input', {'required':props.required}]"
    outlined
    dense
    background-color="#f2f2f2"
  >    
    <template>
      <v-icon slot="append" color="primary" >
        {{ false || "mdi-menu-down" }}
      </v-icon>
    </template>
  </v-select>
</template>


<script>
export default {
  name: 'Select',

  props: ['props'],

  data: () => ({
    valid: true,
  }),

  computed: {
    value() {
      return this.props.value
    },
    rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || 'Campo requerido']
    },
  },

  methods: {
    validate() {
      // TODO: Show error message
      console.log("Select.valid", this.valid)
      return this.valid
    },
    error_state(ok) {
      this.valid = ok
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>